export default __webpack_public_path__ + "static/image-44-983f190080010d0f1f463c1a91b49e54.jpg";